import { useContext } from 'react';
import { FeatureFlagsContext } from 'common/context';

const useFeatureFlags = () => useContext(FeatureFlagsContext);

export default useFeatureFlags;
